import React, { forwardRef } from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import FormControl from '../../../../../Components/Form/FormControl';
import Select from '../../../../../Components/Base/Select/Select';
import { SickLeaveState } from '../../../Enums/SickLeaveState.enum';

interface FilterItem {
	value: string;
	label: string;
}

export interface ManagerSickLeavesFilterValues {
	patientId?: FilterItem;
	doctor?: FilterItem;
	state?: { value: SickLeaveState | null; label: string } | null;
}

interface Props {
	onChange: (values: ManagerSickLeavesFilterValues) => void;
}

const StateFilterItem = forwardRef<
	HTMLDivElement,
	{
		customOnChange?: (item: any) => void;
	}
>(({ customOnChange }, ref) => {
	return (
		<div
			ref={ref}
			className='filterInputWrapper'
			style={{ position: 'relative' }}>
			<FormControl
				labelStyle={{ whiteSpace: 'nowrap' }}
				label='component.CSSZSickLeaveCertificateSubmissionsOverview.status'
				name='state'
				inLine
				hideRequired
				contentWidth={220}
				onChange={() => customOnChange?.({ enableAutocomplete: true })}>
				<Select
					translate
					options={[
						{ value: null, label: 'base.everything' },
						{
							value: SickLeaveState.UNPROCESSED,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusUnprocessed',
						},
						{
							value: SickLeaveState.FILE_MISSING,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusFileMissing',
						},
						{
							value: SickLeaveState.MEDDI_FAIL,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusMeddiFail',
						},
						{
							value: SickLeaveState.CSSZ_FAIL,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszFail',
						},
						{
							value: SickLeaveState.CSSZ_PROCESSING,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszProcessing',
						},
						{
							value: SickLeaveState.CSSZ_REJECTED,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszRejected',
						},
						{
							value: SickLeaveState.CSSZ_ACCEPTED,
							label:
								'component.CSSZSickLeaveCertificateSubmissionsOverview.statusCsszAccepted',
						},
					]}
				/>
			</FormControl>
		</div>
	);
});

const ManagerSickLeavesFilter: React.FC<Props> = ({ onChange }) => {
	return (
		<GridFilter onChange={onChange}>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				customKey='patientId'
				width={340}
				enableAutocomplete
				customLabel='base.shared.patient'
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID_PREFETCH}
				width={320}
				enableAutocomplete
			/>
			<StateFilterItem />
		</GridFilter>
	);
};

export default ManagerSickLeavesFilter;
